<template>
    <div class="tm-distribution tm-info" v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="10">
        <dl v-for="(infoItem, infoIndex) in dataList" :key="infoIndex" @click="redirect(infoItem.id)">
            <dd>
                <p>
                    <span>借款人类型：</span>
                    <span>{{ infoItem.borrowerType }}</span>
                </p>
                <p>
                    <span>借款人：</span>
                    <span>{{ infoItem.borrowerName }}</span>
                </p>
                <p>
                    <span>借款用途：</span>
                    <span>{{ infoItem.loanPurpose }}</span>
                </p>
                <p>
                    <span>借款金额：</span>
                    <span>{{ infoItem.loanAmount }}</span>
                </p>
            </dd>
        </dl>
    </div>
</template>

<script>
import infiniteScroll from "vue-infinite-scroll";
import { bridgeRedirect } from "@/utils/bridge";
export default {
    data() {
        return {
            dataList: [],
            busy: false,
            guaranteeType: "",
            productId: ""
        };
    },
    directives: { infiniteScroll },
    beforeMount() {
        const urlParams = this.$queryUrl(location.href);
        // const { guaranteeType = 1,token } = urlParams; //先默认等于1 等跟app联调再改回去
        const { guaranteeType, token, productId } = urlParams;
        this.guaranteeType = guaranteeType;
        this.productId = productId;
        this.token = decodeURIComponent(token || "");
    },
    methods: {
        loadMore: (function() {
            let pageNo = 1;
            return function() {
                this.$request({
                    url: "/h5/borrowLoans/borrowLoansList",
                    data: this.$qs.stringify({
                        pageNo,
                        guaranteeType: this.guaranteeType
                    })
                })
                    .then(res => {
                        if (res.data.results.length === 0) {
                            return (this.busy = true);
                        }
                        pageNo++;
                        this.dataList.push(...res.data.results);
                    })
                    .catch(err => {
                        this.$toast(err);
                    });
            };
        })(),
        redirect(id) {
            let url = location.origin + location.pathname + "#/rxloanDetails?token=" + this.token + "&id=" + id + "&productId=" + this.productId;
            bridgeRedirect(url);
        }
    }
};
</script>
<style lang="less">
@import "../css/detailsRefund.less";
body {
    background: #f8f8f8 !important;
}
.tm-info {
    dl {
        background-image: linear-gradient(90deg, #fcfcfc 0%, #f8f8f8 100%);
        border-radius: 4px;
        dd {
            text-align: left;
            span:first-child {
                width: 78px;
                display: inline-block;
            }
        }
        &:after {
            position: absolute;
            top: 43%;
            right: -12px;
            background: url("../../.././assets/images/normal/btn_arrow.png") no-repeat;
            background-size: 100% 100%;
            width: 10px;
            height: 10px;
            content: "";
        }
    }
}
</style>
